import { DynamicLayoutComponent } from '@abp/ng.core';
import { InternetConnectionStatusComponent, LoaderBarComponent } from '@abp/ng.theme.shared';
import { Component } from '@angular/core';
import { GdprCookieConsentComponent } from '@volo/abp.ng.gdpr/config';
import { NgxValidateCoreModule } from '@ngx-validate/core';
@Component({
  selector: 'app-root',
  template: `
    <abp-loader-bar />
    <abp-dynamic-layout />
    <abp-gdpr-cookie-consent />
    <abp-internet-status />
  `,
  imports: [
    LoaderBarComponent,
    DynamicLayoutComponent,
    GdprCookieConsentComponent,
    InternetConnectionStatusComponent
  ],
})
export class AppComponent {}
